module.exports = __webpack_public_path__ + "media/arek5.bf9212c2.mp3";